<template>
  <v-text-field
    ref="input"
    :value="value"
    :maxlength="maxlength"
    dense
    outlined
    :disabled="disabled"
    :label="label"
    :error-messages="errorMessages"
    @input="$emit('input', $event)"
    @focus="$event.target.select()"
    @keydown.native="onKeyDown"
    @keyup.native="onKeyUp"
  >
  </v-text-field>
</template>

<script>
import { isNumericKey } from "../../utils/keyboard.js";
import { Backspace } from "../../constants/Keys.js";

export default {
  name: "ResultFieldEditor",
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: String,
      required: false,
      default: ""
    },
    maxlength: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    errorMessages: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    focus() {
      this.$refs.input.focus();
    },
    onKeyDown(event) {
      const isNumeric = isNumericKey(event),
        isBackSpace = event.code === Backspace;

      if (!isNumeric && !isBackSpace) {
        event.preventDefault();
      }
    },
    onKeyUp(event) {
      const isSelected =
        event.target.selectionEnd - event.target.selectionStart ===
        this.maxlength;

      if (event.target.value.length === this.maxlength && !isSelected) {
        this.$emit("complete");
      }
    }
  }
};
</script>

<style scoped></style>
